import {Linking, Platform} from 'react-native';

import {useStores} from '../../stores/use-stores';

import {getStoreDeepLink, getStoreFallbackUrl} from './storeLinks';

export interface ForceUpgradeVersionState {
  currentVersion: string;
  minimumVersion: string;
  onUpdatePress: () => void;
}

/**
 * Handle update button press with deep link + fallback strategy
 * - iOS: itms-apps:// → https://apps.apple.com fallback
 * - Android: market:// → https://play.google.com fallback
 * - Web: window.location.reload()
 */
const handleUpdatePress = async () => {
  if (Platform.OS === 'web') {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
    return;
  }

  const deepLink = getStoreDeepLink();
  const fallbackUrl = getStoreFallbackUrl();

  if (deepLink) {
    try {
      await Linking.openURL(deepLink);
    } catch {
      // Deep link failed, try HTTPS fallback
      if (fallbackUrl) {
        try {
          await Linking.openURL(fallbackUrl);
        } catch (error) {
          console.error('Failed to open store URL:', error);
        }
      }
    }
  }
};

/**
 * Hook that provides version state for ForceUpgradeScreen
 * Reads from globalStore - versions are set during app initialization
 */
export const useForceUpgradeVersion = (): ForceUpgradeVersionState => {
  const {globalStore} = useStores();

  return {
    currentVersion: globalStore.currentAppVersion || '',
    minimumVersion: globalStore.minimumRequiredVersion || 'latest',
    onUpdatePress: handleUpdatePress,
  };
};
